import {TaskDurum} from "../../enum/TaskDurum";

/**
 * Görev listesindeki "Durum" sütunu için gösterim kararı.
 *
 * Sunucuda ayrı bir "saati bekliyor" durumu YOK: senkron paketi SIRADA olarak
 * yazılır, saat `scheduled_at` alanında taşınır ve next-task yalnız saati
 * gelmişse verir. Liste bunu tek başına "Sırada" diye gösterince 10:10'u
 * bekleyen paket, elle açılmış sıradaki bir görevle aynı görünüyordu (8 Eyl).
 * Bu yardımcı üç hâli ayırır; sunucu sözleşmesi değişmez.
 *
 * Saf tutuldu: iki uygulamanın DevamEdenGorevList bileşeni de bunu kullanır,
 * testler bileşen mount etmeden koşar.
 */
export type GorevDurumGosterimi = {
    tur: "zamanlanmis" | "saati-geldi" | "sirada" | "diger";
    ikon: string;
    renk: string | null;
    tooltip: string;
    /** İkonun altında hover'sız görünen kısa metin (saat), yoksa null. */
    altYazi: string | null;
};

const ZAMAN_DILIMI = "Europe/Istanbul";

function tarihParcalari(d: Date, secenekler: any): string {
    // hourCycle/Intl.DateTimeFormatPart vue-imza'nın TS lib kümesinde yok;
    // seçenekler any olarak verilir (bkz. snapshot/tazelik.ts).
    return new Intl.DateTimeFormat("tr-TR", {timeZone: ZAMAN_DILIMI, ...secenekler}).format(d);
}

function tarihiCoz(deger: string | Date | null | undefined): Date | null {
    if (deger === null || deger === undefined || deger === "") {
        return null;
    }
    const d = deger instanceof Date ? deger : new Date(deger);
    return isNaN(d.getTime()) ? null : d;
}

/** "10:10" (aynı gün) ya da "9 Eyl 00:15" (başka gün), İstanbul saatiyle. */
export function zamanlanmisSaatMetni(scheduledAt: string | Date | null | undefined, simdi: Date = new Date()): string | null {
    const d = tarihiCoz(scheduledAt);
    if (d === null) {
        return null;
    }
    const saat = tarihParcalari(d, {hour: "2-digit", minute: "2-digit", hour12: false});
    const gunAyni = tarihParcalari(d, {year: "numeric", month: "2-digit", day: "2-digit"})
        === tarihParcalari(simdi, {year: "numeric", month: "2-digit", day: "2-digit"});
    return gunAyni ? saat : `${tarihParcalari(d, {day: "numeric", month: "short"})} ${saat}`;
}

export function gorevDurumEtiketi(
    status: number,
    scheduledAt: string | Date | null | undefined,
    simdi: Date = new Date()
): GorevDurumGosterimi {
    if (status !== TaskDurum.SIRADA) {
        return {tur: "diger", ikon: "", renk: null, tooltip: "", altYazi: null};
    }
    const d = tarihiCoz(scheduledAt);
    if (d === null) {
        return {tur: "sirada", ikon: "mdi-clock-time-nine-outline", renk: null, tooltip: "Sırada", altYazi: null};
    }
    const saat = zamanlanmisSaatMetni(d, simdi) as string;
    if (d.getTime() > simdi.getTime()) {
        return {
            tur: "zamanlanmis",
            ikon: "mdi-calendar-clock",
            renk: "blue darken-2",
            tooltip: `Zamanlanmış — ${saat}'de başlayacak`,
            altYazi: saat
        };
    }
    return {
        tur: "saati-geldi",
        ikon: "mdi-clock-alert-outline",
        renk: "orange darken-3",
        tooltip: `Sırada — saati geldi (${saat}), botun almasını bekliyor`,
        altYazi: saat
    };
}
